import React from 'react';
import PropTypes from 'prop-types';
import Idea from '../../Components/Idea';

const ConnectorList = (props) => {
  return (
    <React.Fragment>
      <div className="grey-font slds-m-top_small slds-p-horizontal_large">
        <div className="slds-grid">
          <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Trigger</div>
          <div className="slds-size_4-of-5">
            <Idea
              milestone={"Milestone"}
              headerActions={false}
              chosen={true}
              outline={props.currentMilestone === 'trigger' ? false : true}
              heading=""
              ideaContent={props.milestones["trigger"].content || ''}
            />
          </div>
        </div>
        
        {props.currentMilestone === 'guide' || props.currentMilestone === 'keyVar' || props.currentMilestone === 'crisis' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Guide</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={"Milestone"}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'guide' ? false : true}
                heading=""
                ideaContent={props.milestones["guide"].content || ''}
              />
            </div>
          </div>
        ) : null}

        {props.currentMilestone === 'keyVar' || props.currentMilestone === 'crisis' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Key</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={"Milestone"}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'keyVar' ? false : true}
                heading=""
                ideaContent={props.milestones["key"].content || ''}
              />
            </div>
          </div>
        ) : null}

        {props.currentMilestone === 'crisis' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Crisis</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={"Milestone"}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'crisis' ? false : true}
                heading=""
                ideaContent={props.milestones["crisis"].content || ''}
              />
            </div>
          </div>
        ) : null} 
        <div className="slds-m-horizontal_large">
          {props.milestones[props.milestone].connectorIds.length > 0 ? (
            props.milestones[props.milestone].connectorIds.map((connectorId) => {
                const connector = props.connectors[props.currentMilestone][connectorId];

                if (connector !== undefined) {
                  return (
                    <Idea
                      key={connector.id}
                      id={connector.id}
                      headerActions={true}
                      heading={connector.title}
                      milestone={'Connector'}
                      connector={connector}
                      ideaTitle={connector.title}
                      ideaContent={connector.content}
                      onDropdownSelected={props.onDropdownSelected}
                    />
                  )
                }
              })
          ) : (
            <Idea
              connector={true}
              headerActions={false}
              heading="Placeholder"
              milestone={'Connector'}
              ideaContent="When you add connectors they will show up here"
              key={999}
              id={999}
              onDropdownSelected={() => null}
            />
          )}
        </div>

        {props.currentMilestone === 'trigger' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Guide</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={"Milestone"}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'trigger' ? false : true}
                heading=""
                ideaContent={props.milestones["guide"].content || ''}
              />
            </div>
          </div>
        ) : null}

        {props.currentMilestone === 'trigger' || props.currentMilestone === 'guide' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Key</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={"Milestone"}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'guide' ? false : true}
                heading=""
                ideaContent={props.milestones["key"].content || ''}
              />
            </div>
          </div>
        ) : null}

        {props.currentMilestone === 'trigger' || props.currentMilestone === 'guide' || props.currentMilestone === 'keyVar' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Crisis</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={"Milestone"}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'keyVar' ? false : true}
                heading=""
                ideaContent={props.milestones["crisis"].content || ''}
              />
            </div>
          </div>
        ) : null} 

        {props.currentMilestone === 'trigger' || props.currentMilestone === 'guide' || props.currentMilestone === 'keyVar' || props.currentMilestone === 'crisis' ? (
          <div className="slds-grid">
            <div className="slds-size_1-of-5 slds-align_absolute-center slds-text-title_caps">Triumph</div>
            <div className="slds-size_4-of-5">
              <Idea
                milestone={'Milestone'}
                headerActions={false}
                chosen={true}
                outline={props.currentMilestone === 'crisis' ? false : true}
                heading=""
                ideaContent={props.milestones["triumph"].content || ''}
              />
            </div>
          </div>
          ) : null} 
      </div>
    </React.Fragment>
  );
};

ConnectorList.propTypes = {
  milestones: PropTypes.object.isRequired,
  currentMilestone: PropTypes.string.isRequired,
  nextMilestone: PropTypes.string.isRequired,
  connectors: PropTypes.object,
  onDropdownSelected: PropTypes.func.isRequired,
};

export default ConnectorList;
